module.exports = __webpack_public_path__ + "static/media/PEN-200_Course_Completion.a076d4ee.png";